// extracted by mini-css-extract-plugin
export default {"tag":"tagRenderer__tag--_FOXfrSIu1JYWRVZ1NQh","notAssigned":"tagRenderer__notAssigned--S997h05kBpcG_ccIlkp7"};